import React from "react";
import { Box, SvgIcon } from "@mui/material";

export const BatteryIcon = (props) => (
	<Box sx = {{ 
		
		width: '32px', 
		height: '32px', 
		background: '#EEEEEE', 
		borderRadius: '6.2px', 
		display: 'flex', 
		alignItems: 'center', justifyContent: 'center'
	}} >
		<SvgIcon viewBox="0 0 18 18" sx = {{height:'18px', width:'auto', ...props}} >
			<path d="M5.8418 14.625V3.375H12.5918V14.625H5.8418Z" fill="#929292"/>
			<path d="M3.5918 13.8802C3.60305 14.8241 3.57492 15.5126 3.88655 16.0774C4.0418 16.3598 4.30617 16.5836 4.6358 16.7074C4.9643 16.8311 5.3558 16.875 5.84855 16.875H12.5918C13.0845 16.875 13.476 16.8311 13.8045 16.7085C14.1342 16.5848 14.3963 16.3597 14.5515 16.0785C14.8632 15.5126 14.8305 14.8241 14.8418 13.8802V4.08488C14.8305 3.141 14.8632 2.45025 14.5515 1.8855C14.3857 1.59338 14.1207 1.3703 13.8045 1.25662C13.476 1.13287 13.0845 1.125 12.5918 1.125H11.4668V0H6.9668V1.125H5.84855C5.3558 1.125 4.9643 1.13287 4.6358 1.25662C4.30617 1.38038 4.0418 1.60312 3.88655 1.8855C3.57492 2.45025 3.60305 3.141 3.5918 4.08488V13.878V13.8802ZM4.7168 13.8645V4.08712C4.72805 3.1275 4.7618 2.62687 4.87092 2.42775C4.90917 2.37133 4.96552 2.32966 5.03067 2.30962C5.10042 2.28375 5.36817 2.25 5.84855 2.25H12.5918C13.0722 2.25 13.3388 2.28375 13.4097 2.30962C13.4743 2.32953 13.53 2.37129 13.5672 2.42775C13.674 2.62238 13.7055 3.123 13.7168 4.08712V13.8802C13.7055 14.841 13.674 15.3405 13.5672 15.534C13.5492 15.5677 13.5053 15.6172 13.4097 15.6532C13.2713 15.705 13.017 15.75 12.5918 15.75H5.84855C5.4233 15.75 5.16905 15.705 5.03067 15.6532C4.96552 15.6332 4.90917 15.5915 4.87092 15.5351C4.76067 15.3349 4.72805 14.8376 4.7168 13.8645Z" fill="#929292"/>
		</SvgIcon>
	</Box>
);


